<template>
  <div class="main">
    
    <a-form  :form="form" class="login-form" @submit="handleSubmit">
      <h1 style="text-align: center;margin: 20px;">车间日报管理系统</h1>
      <a-form-item>
        <a-input v-decorator="['account',{ rules: [{ required: true, message: '请输入用户名' }] },]" placeholder="用户名">
          <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input v-decorator="['password',{ rules: [{ required: true, message: '请输入密码' }] },]" type="password"
          placeholder="密码">
          <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit" class="login-form-button">
          登录
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
  var storage = window.localStorage;
  export default {
    data() {
      return {
        form:this.$form.createForm(this)
      }
    },
    created() {
    },
    methods: {
      handleSubmit(e) {
        e.preventDefault();
        this.form.validateFields((err, values) => {
          if (!err) {
            let params = {
              account: values.account,
              password: values.password,
            }
            this.$request.post('/index.php/admin/index/login', params).then((res) => {
              console.log(res.data)
              if (res.data.code == 200) {
                this.$message.success(res.data.msg);
                storage.loginStatus = 1;
                storage.adminId = res.data.data.id;
                storage.account = res.data.data.account;
                storage.sf = res.data.data.sf;
                setTimeout(() => {
                  this.$router.push('/')
                }, 300)
              }else{
                this.$message.error('登录失败');
              }
            }).catch(err => {
              console.log(err)
            })
          }
        });
      }
    }
  }
</script>

<style scoped="scoped">
  .main{
    background:#e8e8e8 ;
    display: flex;
		height: 100vh;
    align-items: center;
    background-image: url(https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg);
    background-repeat:no-repeat;
		background-size:100%;
		background-position:center 110px;
  }
   .login-form {
    width: 400px;
    margin:0 auto ;
    padding:30px;
    background: white;
    border-radius: 10px;
  }
   .login-form-forgot {
    float: right;
  }
   .login-form-button {
    width: 100%;
  }
  
  .title {
    font-size: 1.5rem;
    color: #409EFF;
  }

  .loginwrap {
    height: 100vh;
    margin-bottom: 2rem;
  }

  .inpt {
    margin-bottom: 30px;
    width: 100%;
  }

  .main {}

  .box {
    border-radius: 5px;
    box-shadow: 0 0 45px 0 rgba(0, 0, 0, 0.12);
  }
</style>
